import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorGraphicsCardMemorySize,
  fetchProcessorGraphicsCardMemoryById,
  fetchProcessorGraphicsCardMemorySize,
  updateProcessorGraphicsCardMomerySize,
  updateStatusInProcessorGraphicsCardMomerySize,
} from "./thunk";

interface CategoryState {
  graphics_card_memory_size_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  graphics_card_memory_size_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "graphics_card_memory_size",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorGraphicsCardMemorySize.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorGraphicsCardMemorySize.fulfilled, (state, action) => {
        state.loading = false;
        state.graphics_card_memory_size_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorGraphicsCardMemorySize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorGraphicsCardMemoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorGraphicsCardMemoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorGraphicsCardMemoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorGraphicsCardMemorySize.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.graphics_card_memory_size_list = state.graphics_card_memory_size_list.map((graphics_card_memory_size) =>
          graphics_card_memory_size.id === action.payload.id ? action.payload : graphics_card_memory_size
        );
      })
      .addCase(addProcessorGraphicsCardMemorySize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorGraphicsCardMomerySize.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.graphics_card_memory_size_list = state.graphics_card_memory_size_list.map((graphics_card_memory_size) =>
          graphics_card_memory_size.id === action.payload.id ? action.payload : graphics_card_memory_size
        );
      })
      .addCase(updateProcessorGraphicsCardMomerySize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorGraphicsCardMomerySize.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorGraphicsCardMomerySize.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
